// extracted by mini-css-extract-plugin
export var divider = "_48-0";
export var dividerText = "_48-1";